<!-- Sidebar Overlay -->
<div class="add-rate-card-sidebar-overlay"
    [class.show]="isVisible"
    (click)="hide()">
</div>

<!-- Sidebar Panel -->
<div class="add-rate-card-sidebar"
    [class.show]="isVisible">

    <!-- Header -->
    <div class="sidebar-header">
        <h4 class="sidebar-title">Add Rate Card Item</h4>
        <button type="button"
            class="close-btn"
            (click)="hide()">
            <i class="material-icons-round">close</i>
        </button>
    </div>

    <!-- Body -->
    <div class="sidebar-body">
        <div class="table-card mt-3">
            <table class="table mb-0">
                <thead>
                    <tr>
                        <th width="35%">Item</th>
                        <th width="20%">Code</th>
                        <th width="20%">Unit</th>
                        <th width="25%">Rate</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of items; let i = index">
                        <td>
                            <input type="text"
                                class="form-control form-control-sm add-item-input"
                                [class.is-invalid]="isFieldInvalid(item, 'itemName')"
                                [(ngModel)]="item.itemName"
                                maxlength="50"
                                placeholder="Item name">
                        </td>
                        <td>
                            <input type="text"
                                class="form-control form-control-sm add-item-input"
                                [class.is-invalid]="isFieldInvalid(item, 'itemCode')"
                                [(ngModel)]="item.itemCode"
                                maxlength="50"
                                placeholder="Code">
                        </td>
                        <td>
                            <input type="text"
                                class="form-control form-control-sm add-item-input"
                                [class.is-invalid]="isFieldInvalid(item, 'unit')"
                                [(ngModel)]="item.unit"
                                (keypress)="onUnitKeyPress($event)"
                                maxlength="10"
                                placeholder="Unit">
                        </td>
                        <td>
                            <input type="number"
                                class="form-control form-control-sm add-item-input"
                                [class.is-invalid]="isFieldInvalid(item, 'rate')"
                                [(ngModel)]="item.rate"
                                max="9999999999"
                                placeholder="Rate">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Footer -->
    <div class="sidebar-footer">
        <div class="d-flex justify-content-end">
            <button type="button"
                class="btn-submit"
                [disabled]="isSubmitting || isFormInvalid()"
                (click)="onSubmit()">
                <span *ngIf="!isSubmitting">Submit</span>
                <span *ngIf="isSubmitting">Submitting...</span>
            </button>
        </div>
    </div>
</div>